// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__egUo7","link":"Menu_link__v+pqE","bars":"Menu_bars__GdVYg","bar":"Menu_bar__CCUvc","side-bar":"Menu_side-bar__HR9jV","anchor":"Menu_anchor__qyFM-"};